import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthInterceptors } from "@/lib/authInterceptors";
import { installerCaptureGlobale } from "@/lib/telemetrieErreurs";

// R2-FRONT : injecter le Bearer sur les appels /api AVANT tout render/appel.
installAuthInterceptors();

// 🔴 N°1001-C2 — trace NETTOYÉE de toute exception non interceptée (cf. lib/telemetrieErreurs).
installerCaptureGlobale();

// Titre d'onglet par environnement — DÉRIVÉ du hostname (jamais en dur) :
// un host contenant "preprod" → suffixe " - Preprod" ; prod (omnihub-ia.fr, pas de
// "preprod" dans le host) → "OmniHub" inchangé. Le même build est donc sûr en prod.
document.title = /preprod/i.test(window.location.hostname)
  ? "OmniHub - Preprod"
  : "OmniHub";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
